import { h } from 'preact';

import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';

import styles from '../global.css';

export default function LazyLcpHistory(_props) {
  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} md={5} className={styles.selectorInfoItem}>
        <Paper className={styles.selectorInfo}>
          <Typography variant="h6">
            <Skeleton width={'100%'} />
          </Typography>
          <Skeleton width={'100%'} height={225} />
        </Paper>
      </Grid>
    </Grid>
  );
}
